/**
 * Формат номера карты
 * @param value Исходное значение
 * @returns Форматированное значение
 */
export default function cardNumberFilter(value: string, hideSymbols: boolean = true): string {
  if (!value)
    return '';

  if (value.indexOf('*') < 0 && hideSymbols)
    value = value.substring(0, 4) + '********' + value.substring(12);

  value = value.split("*").join("X");

  return value.split("").reduce((acc, val, i) => {
    if (i === 3) return acc + val + " ";
    else if (i === 7) return acc + val + " ";
    else if (i === 11) return acc + val + " ";
    return acc + val;
  });
}
